/**
 * Build a tutor-shaped object for TutorCard (preview mode) from form state.
 */

export function previewLocationFromAddForm(formData) {
  const isYerevan = formData.region === 'Երևան';
  const city = isYerevan ? 'Երևան' : String(formData.city || '').trim();
  if (isYerevan && formData.district) return `${formData.district}, ${city}`;
  if (city) return city;
  if (formData.region) return formData.region;
  return '';
}

export function displayLocationFromGeo(form) {
  const d = String(form.district || '').trim();
  const c = String(form.city || '').trim();
  const r = String(form.region || '').trim();
  if (d && c) return `${d}, ${c}`;
  if (c) return c;
  if (r) return r;
  return String(form.location || '').trim();
}

export function buildTutorPreviewForCard({
  id = 0,
  name,
  photo,
  subjects,
  hourlyRate,
  experienceYears,
  location,
  modes,
  description,
}) {
  const subj = Array.isArray(subjects) ? subjects.filter(Boolean) : [];
  const modeList = Array.isArray(modes) && modes.length ? modes : ['Online'];
  const exp = experienceYears !== '' && experienceYears != null
    ? String(experienceYears)
    : '0';

  return {
    id,
    name: (name || '').trim() || 'Անուն',
    photo: photo || null,
    subjects: subj.length ? subj : ['Ոլորտ ընտրեք'],
    hourlyRate: Math.max(0, Number(hourlyRate) || 0),
    experience: `${exp} տարի`,
    location: (location || '').trim() || 'Տեղադրություն',
    modes: modeList,
    description: (description || '').trim() || 'Նկարագիրը կերևա այստեղ։',
  };
}

/**
 * Full public profile shape for TutorProfile: merge unsaved edit form over last server payload
 * (from fetchMyTutor). Keeps messaging, reviews, status, and extra analytics fields from server.
 */
export function buildPublicProfilePreviewFromDraft(serverTutor, form, savedPhoto) {
  if (!serverTutor) return null;
  const phone = (form.phone || '').trim();
  const email = serverTutor.email || '';
  const exp =
    form.experience !== '' && form.experience != null ? String(form.experience) : '0';
  const addInfo = (form.additionalInfo || '').trim();

  return {
    ...serverTutor,
    name: (form.name || '').trim() || serverTutor.name,
    phone,
    location:
      displayLocationFromGeo(form) || (form.location || '').trim() || serverTutor.location,
    hourlyRate: Math.max(0, parseInt(String(form.hourlyRate), 10) || 0),
    experience: `${exp} տարի`,
    description: (form.description || '').trim() || serverTutor.description,
    additionalInfo: addInfo || null,
    subjects: Array.isArray(form.subjects) ? [...form.subjects] : [],
    modes: Array.isArray(form.modes) ? [...form.modes] : [],
    photo: savedPhoto != null ? savedPhoto : serverTutor.photo,
    contact: {
      ...(serverTutor.contact || {}),
      email,
      phone,
    },
  };
}
